class ShildnReveal extends HTMLElement {
  connectedCallback() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      this.classList.add('shildn-reveal--visible');
      return;
    }
    if (!('IntersectionObserver' in window)) {
      this.classList.add('shildn-reveal--visible');
      return;
    }

    const delay = parseInt(this.dataset.delay || '0', 10);
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          window.setTimeout(() => {
            this.classList.add('shildn-reveal--visible');
          }, delay);
          observer.unobserve(this);
        });
      },
      { rootMargin: '0px 0px -50px 0px', threshold: 0.1 }
    );
    observer.observe(this);
  }
}

customElements.define('shildn-reveal', ShildnReveal);
